import React from 'react';
import PropTypes from 'prop-types';
import ColorsListItem from './ColorsListItem';
import PopupButton from '../popup/PopUpButton';

const ColorListGroup = props => {
  const { colorsList, changeMaterial, title, frontColor } = props;

  const titleToShow = title.replace('-', ':');

  return (
    <div className="color-list__group">
      <PopupButton
        popupName="colors-group"
        text={titleToShow}
        icon={`${title.length === 0 ? null : 'help-circle'}`}
      />
      <ColorsListItem
        colorsList={colorsList}
        changeMaterial={changeMaterial}
        colorName={frontColor}
      />
    </div>
  );
};

ColorListGroup.propTypes = {
  group: PropTypes.object,
  title: PropTypes.string,
  colorsList: PropTypes.array,
  frontColor: PropTypes.string,
};

export default ColorListGroup;
